import React, { FC, useCallback } from "react";
import { SeriesId } from "@mui/x-charts/internals";
import { DateTime, Duration } from "luxon";
import { useXAxis } from "@mui/x-charts-premium";
import { LineAnnotation } from "./LineAnnotation";

export interface TimeLineAnnotationProps {
  seriesId: SeriesId | undefined;
  timeAxisId?: string;
  time: DateTime | Duration;
  label: string;
  color?: string;
  onClick?: (time: DateTime | Duration) => void;
}

export const TimeLineAnnotation: FC<TimeLineAnnotationProps> = (props) => {
  const { seriesId, time, timeAxisId, label, color, onClick } = props;
  const xAxis = useXAxis(timeAxisId);

  // Find the closest x index for the provided time
  const dataIndex: number | undefined = xAxis.data?.findIndex((it) =>
    time.equals(it)
  );

  const handleClick = useCallback(() => {
    if (onClick) onClick(time);
  }, [onClick, time]);

  return (
    <LineAnnotation
      seriesId={seriesId}
      dataIndex={dataIndex}
      label={label}
      color={color}
      onClick={onClick ? handleClick : undefined}
    />
  );
};
